import { render, staticRenderFns } from "./Assessmenttaskuserenter.vue?vue&type=template&id=16f771ea&scoped=true"
import script from "./Assessmenttaskuserenter.vue?vue&type=script&lang=js"
export * from "./Assessmenttaskuserenter.vue?vue&type=script&lang=js"
import style0 from "./Assessmenttaskuserenter.vue?vue&type=style&index=0&id=16f771ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f771ea",
  null
  
)

export default component.exports